export default "__VITE_PUBLIC_ASSET__24181ea8__"